// extracted by mini-css-extract-plugin
module.exports = {"_opened":"Block__opened__3WCRq","inner":"Block_inner__wJv66"};